import React from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import classNames from 'classnames';
import { SecondaryButton } from '@gje/buttons';
import { cleanError } from '../../../actions/error-actions';

const createMarkup = (message: any) => {
    return { __html: message };
};

const messageComponent = (message: any) => {
    return <div dangerouslySetInnerHTML={createMarkup(message)} />;
};

const ErrorBar = ({ message, cleanError }) => {
    return (
        <>
            {message && (
                <div
                    id="scroll-trigger-out"
                    className={classNames(
                        'inactive',
                        'error-bar',
                        'sticky-bar-top',
                        'sticky-bar-visible'
                    )}>
                    <div className="container message-modal">
                        <SecondaryButton
                            children={'X'}
                            onClick={() => cleanError()}
                            className={'error-close-button no-underline'}
                        />
                        <div className="row">
                            {isMobile ? (
                                <h3>{messageComponent(message)}</h3>
                            ) : (
                                <h1>{messageComponent(message)}</h1>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const mapStateToProps = state => ({
    message: state.errorBar.message
});

export default connect(mapStateToProps, { cleanError })(ErrorBar);
